import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/jenkins/workspace/prod/rollback-frontend/src/hocs/TranslationsProvider/TranslationsProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["HomePageTemplate"] */ "/home/jenkins/workspace/prod/rollback-frontend/src/templates/HomePageTemplate/HomePageTemplate.tsx");
